import helper from '@/libs/forms';


export default {
  schema: {
    fields: [
      helper.currency('Salary', 'salary', false, 6),
      helper.currency('Net Investment Income', 'netInvestmentIncome', false, 6),
      helper.currency('Real Estate Income', 'realEstateIncome', false, 6),
      helper.currency('Other Income', 'otherIncome', false, 6),
    ],
  },
  formOptions: helper.options('financial-income-', true),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/income/schema.js